<template>
  <div>
    <div v-if="model===false">
         <div class="totalmakeHole" ref="total">
      <div class="makeHole1">
        <kefu @toptop="topTop"></kefu>
        <div class="topback"  :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' ,position:'fixed'}">
          <headtip  :changeVisable="changeVisable" @showDialog="showPartner"></headtip>
        </div>
                <div @click="changeheadVisable">
        <div class="background">
            <!--     文字-->
            <div class="titlle1">油气开发作业GPT应用项目服务</div>
            <div class="title4">帮助企业客户打造油气开发作业GPT应用项目服务，借助AI、大数据、IoT等技术，通过GPT与边缘智能融合，实现油藏地质、钻井、压裂、采油气、地层监测和设备设施监测的一体化智能解决方案，助力油气企业优化施工，改进工艺及流程，提高开发经济效益。</div>
            <div class="titlle3" @click="clickConsult('油气通')">
              产品咨询
            </div>


          </div>
          <div class="screenmake0">
            <div class="heighLight">油气开发作业GPT应用项目服务
            </div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign">
                    <img loading="lazy" src="@/assets/oilApplication6.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                     安东在油气开发领域利用 AI 技术已有具体应用落地，在钻井领域，实现智能地质导向；在压裂领域，实现产量 EUR 预测和压裂工程智能设计；在光纤监测领域，基于光纤监测的DAS声波数据、DTS温度数据监控井筒漏点等。   </div>
                  </div>
                </div>


              </div>
            </div>

          </div>
          <div class="screenmake1">
            <div class="heighLight">GPT辅助智能地质导向</div>
            <div class="grid">
              <div class="card">
                <div class="back">

                  <div class="titleDesign">
                    <div class="title2">
                      在钻井过程中通过测量多种地质和工程参数来对所钻地层的地质参数进行实时评价，根据评价结果来精确的控制井下钻具命中最佳地质目标。 </div>
                  </div>
                  <div class="imgDesign">
                    <img loading="lazy" src="@/assets/oilApplication2.png">
                  </div>
                </div>


              </div>
            </div>

          </div>
          <div class="screenmake0">
            <div class="heighLight">GPT辅助光纤漏点智能监测</div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign">
                    <img loading="lazy" src="@/assets/oilApplication3.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                      <li>实时监测分布式温度声波信号、低频应变信号；</li>
                      <li>漏点异常监测预警及定位；</li>
                      <li>管柱震动评价；</li>
                      <li>漏点原因分析；</li>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div class="screenmake1">
            <div class="heighLight">GPT辅助压裂施工参数设计与优化</div>
            <div class="grid">
              <div class="card">
                <div class="back">

                  <div class="titleDesign">
                    <div class="title2">
                      压裂措施的增产效果，以尽可能小的投资获得最大的回报，就需要对影响压裂井的因素进行分析。以理论油藏模型和油田实际油藏模型为基础引进敏感系数，通过比较敏感系数绝对值的大小，对压裂井增产效果影响因素进行分析判断。      </div>
                </div>
                  <div class="imgDesign">
                    <img loading="lazy" src="@/assets/oilApplication4.png">
                  </div>
                </div>


              </div>
            </div>

          </div>
          <div class="screenmake0">
            <div class="heighLight">智能采油机器人</div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign">
                    <img loading="lazy" src="@/assets/oilApplication5.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                      针对抽油机井，实时采集压力温度、电参、示功图、动液面等数据，输入到智能采油机器人工艺脑，输出得到最优化生产运行参数，减少无效冲次，杜绝空抽，使抽油机在最佳工况下运行，油井能够保持动液面稳定，达到了油井供采平衡，实现了油井的稳产增产。   </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div class="screenmake1">
            <div class="heighLight">GPT辅助钻修机监测及预测性维护</div>
            <div class="grid">
              <div class="card" style="height: 40vh">
                <div class="back">
                  <div class="titleDesign">
                    <div class="title2" style="margin-top: -3vh">
                      建设钻修机设备预测性维护平台，实现设备在线状态监测（智能预警、智能诊断、智能评估等），目前已在中海油海上平台上取得成果应用。  </div>
                  </div>
                  <div class="imgDesign">
                    <img loading="lazy" src="@/assets/oilApplication7.png">
                  </div>
                </div>
              </div>
            </div>

          </div>
          <bottomTip></bottomTip></div>
        </div>
        <partnerTip
            :dialogVisible="dialogconsult"
            @hideDialog="hide"
        ></partnerTip>
         <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
      </div>
    </div>
    <div v-else>
      <div class="totalmakeHoleModel" ref="totalModel">
        <div class="makeHole1">
        <kefuMobile @topMobile="topTopmobile"></kefuMobile>
          <div class="background">
            <!--      logo  you气通GPT社区 合作伙伴  登录-->
            <headtip @showDialog="showPartner"></headtip>
            <!--     文字-->
            <div class="layer2">
              <div class="titlle1">油气开发作业GPT应用项目服务</div>
              <div class="title4">帮助企业客户打造油气开发作业GPT应用项目服务，借助AI、大数据、IoT等技术，通过GPT与边缘智能融合，实现油藏地质、钻井、压裂、采油气、地层监测和设备设施监测的一体化智能解决方案，助力油气企业优化施工，改进工艺及流程，提高开发经济效益。</div>

            </div>
             <div class="title3" @click="clickConsult('油气通')">
              产品咨询
            </div>


          </div>
          <div class="screenmake0">
            <div class="heighLight">油气开发作业GPT应用项目服务
            </div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign" style="height: 180px">
                    <img loading="lazy" src="@/assets/oilApplication6.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                      安东在油气开发领域利用 AI 技术已有具体应用落地，在钻井领域，实现智能地质导向；在压裂领域，实现产量 EUR 预测和压裂工程智能设计；在光纤监测领域，基于光纤监测的DAS声波数据、DTS温度数据监控井筒漏点等。   </div>
                  </div>
                </div>


              </div>
            </div>

          </div>
          <div class="screenmake1">
            <div class="heighLight">GPT辅助智能地质导向</div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign">
                    <img loading="lazy" src="@/assets/oilApplication2.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                      在钻井过程中通过测量多种地质和工程参数来对所钻地层的地质参数进行实时评价，根据评价结果来精确的控制井下钻具命中最佳地质目标。 </div>
                  </div>

                </div>


              </div>
            </div>

          </div>
          <div class="screenmake0">
            <div class="heighLight">GPT辅助光纤漏点智能监测</div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign" style="height: 180px">
                    <img loading="lazy" src="@/assets/oilApplication3.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                      <li>实时监测分布式温度声波信号、低频应变信号；</li>
                      <li>漏点异常监测预警及定位；</li>
                      <li>管柱震动评价；</li>
                      <li>漏点原因分析；</li>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div class="screenmake1">
            <div class="heighLight">GPT辅助压裂施工参数设计与优化</div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign" style="height: 170px">
                    <img loading="lazy" src="@/assets/oilApplication4.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                      压裂措施的增产效果，以尽可能小的投资获得最大的回报，就需要对影响压裂井的因素进行分析。以理论油藏模型和油田实际油藏模型为基础引进敏感系数，通过比较敏感系数绝对值的大小，对压裂井增产效果影响因素进行分析判断。      </div>
                  </div>

                </div>


              </div>
            </div>

          </div>
          <div class="screenmake0">
            <div class="heighLight">智能采油机器人</div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign" style="height: 180px">
                    <img loading="lazy"   src="@/assets/oilApplication5.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                      针对抽油机井，实时采集压力温度、电参、示功图、动液面等数据，输入到智能采油机器人工艺脑，输出得到最优化生产运行参数，减少无效冲次，杜绝空抽，使抽油机在最佳工况下运行，油井能够保持动液面稳定，达到了油井供采平衡，实现了油井的稳产增产。   </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div class="screenmake1">
            <div class="heighLight">GPT辅助钻修机监测及预测性维护</div>
            <div class="grid">
              <div class="card">
                <div class="back">
                  <div class="imgDesign" style="height: 160px">
                    <img loading="lazy" src="@/assets/oilApplication7.png">
                  </div>
                  <div class="titleDesign">
                    <div class="title2">
                      建设钻修机设备预测性维护平台，实现设备在线状态监测（智能预警、智能诊断、智能评估等），目前已在中海油海上平台上取得成果应用。  </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
          <bottomTip></bottomTip>
        </div>
        <partnerTip
            :dialogVisible="dialogconsult"
            @hideDialog="hide"
        ></partnerTip>
         <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
      </div>
    </div>
  </div>



</template>


<script>

import headtip from "@/views/headTip.vue";
import kefu from "@/views/kefu.vue";
import kefuMobile from "@/views/kefuMobile.vue";
import bottomTip from "@/views/bottomTip.vue";
import consultTip from "@/components/consultTip.vue";
import PartnerTip from "@/components/partnerTip.vue";
import {shareUrl} from "@/utils/vxshare";
export default {

  name: "",

  props: [],

  components: {PartnerTip, consultTip, headtip,bottomTip,kefu,kefuMobile},

  data() {

       return {title:"",
      pageTitle: '油气开发作业GPT应用项目服务_安迅油气通-油气通GPT',
      pageDescription: '安迅油气通智能技术有限公司专注为石油行业提供人工智能技术解决方案，提供油气开发作业GPT应用项目服务，帮助企业客户打造油气开发作业GPT应用项目服务，借助AI、大数据、IoT等技术，通过GPT与边缘智能融合，实现油藏地质、钻井、压裂、采油气、地层监测和设备设施监测的一体化智能解决方案，助力油气企业优化施工，改进工艺及流程，提高开发经济效益。',
      pageKeywords: '油气开发作业GPT，油气开发GPT，安迅油气通智能技术有限公司，油气通，油气通GPT，油气通GPT云平台',
      scrollback:false,
      model:false,
      dialogconsult:false,
      dialogVisible:false,
      success:[{
        img:require("@/assets/oilApplication2.png"),
        title1:"GPT辅助智能地质导向",
        title2:"在钻井过程中通过测量多种地质和工程参数来对所钻地层的地质参数进行实时评价，根据评价结果来精确的控制井下钻具命中最佳地质目标。",
      },{
        img:require("@/assets/oilApplication3.png"),
        title1:"GPT辅助光纤漏点智能监测",
        title2:"<li>实时监测分布式温度声波信号、低频应变信号；</li><li>漏点异常监测预警及定位；</li><li>管柱震动评价；</li><li>漏点原因分析；</li>",
      },
        {
          img:require("@/assets/oilApplication4.png"),
          title1:"GPT辅助压裂施工参数设计与优化",
          title2:"压裂措施的增产效果，以尽可能小的投资获得最大的回报，就需要对影响压裂井的因素进行分析。以理论油藏模型和油田实际油藏模型为基础引进敏感系数，通过比较敏感系数绝对值的大小，对压裂井增产效果影响因素进行分析判断。\n" +
              "\n",
        },
        {
          img:require("@/assets/oilApplication5.png"),
          title1:"智能采油机器人",
          title2:"针对抽油机井，实时采集压力温度、电参、示功图、动液面等数据，输入到智能采油机器人工艺脑，输出得到最优化生产运行参数，减少无效冲次，杜绝空抽，使抽油机在最佳工况下运行，油井能够保持动液面稳定，达到了油井供采平衡，实现了油井的稳产增产。",
        },

      ]
    }
  },

  methods: {    topTopmobile() {
      console.log("fuzujianchuanzhi")
      const element = this.$refs.totalModel;
      const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      this.$nextTick(() => {
        this.$refs.totalModel.scrollTop = rect
      });
    },
    topTop() {
      console.log("fuzujianchuanzhi")
      const element = this.$refs.total;
      const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      this.$nextTick(() => {
        this.$refs.total.scrollTop = rect
      });
    },    changeheadVisable(){
      if(this.changeVisable===1){
        this.changeVisable=0
      }
      else{
        this.changeVisable=1
      }
      console.log("父组件", this.changeVisable)
    },
    clickConsult(item){

      this.title=item
      this.dialogVisible = true;
      sessionStorage.setItem('title',item)
    },
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', this.pageDescription);
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.pageKeywords);
      }
    },
    hide(){
      this.dialogconsult=false;
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    showPartner(){
      this.dialogconsult=true;
    },
    skipp3() {
      const element = this.$refs.bottom;
      const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);

      this.$nextTick(() => {
        this.$refs.totalModel.scrollTop = rect
      });
    },
  },

  mounted() {
    document.title=this.pageTitle;
    this.setMetaTags();
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

// Log the values1731 809   1653 834   1912 932
    console.log("Screen Width: ", screenWidth);
    console.log("Screen Height: ", screenHeight);
    if(screenWidth<=700){
      this.model=true
    }else{
      this.model=false
    }

    if (localStorage.getItem("skip") === '3') {
      this.$nextTick(() => {
        this.skipp3();
      });
    }
  },
  created() {
    localStorage.setItem("home",0)
    let url = window.location.href
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url: url,
        pageTitle: '油气开发作业GPT应用项目服务_安迅油气通-油气通GPT',
        pageDescription: '安迅油气通智能技术有限公司专注为石油行业提供人工智能技术解决方案，提供油气开发作业GPT应用项目服务，帮助企业客户打造油气开发作业GPT应用项目服务，借助AI、大数据、IoT等技术，通过GPT与边缘智能融合，实现油藏地质、钻井、压裂、采油气、地层监测和设备设施监测的一体化智能解决方案，助力油气企业优化施工，改进工艺及流程，提高开发经济效益。',
        pageKeywords: '油气开发作业GPT，油气开发GPT，安迅油气通智能技术有限公司，油气通，油气通GPT，油气通GPT云平台',

      };
      shareUrl(shareData);
    }, 1000);
  },

}

</script>


<style type="text/scss" lang="scss" scoped>
.totalmakeHole{
  background: #ebf1fd;
  overflow-x: hidden;
  width: 100vw;
  height: auto;
  position: relative;
  .makeHole1 {
    //z-index:: 3;
    position: relative;
    width: 100%;
    height: 100vh;
 .topback{
    position: fixed;
    z-index:999;
      width: 100vw;
      padding: 0 0 0 2.86077411900635vw;
    }
    .background{
      padding: 7.84301606922126vh 2.86077411900635vw  2.84301606922126vh 2.86077411900635vw;
      width: 100%;
      height: 72.41285537700865vh;
      background-image: url("../../assets/menageBanner.png");
      background-position: center;
      background-size:cover;
      background-repeat: no-repeat;
      background-color: transparent;
      /* Add any additional styling as needed */
      .titlle1 {
        margin-top: 15.09270704573548vh;
        text-align: center;
        font-size: 3.0151935298vw;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #111111;
        line-height: 2.84301606922126vh

      }
      .title4 {
        text-align: center;
        margin: 8.82076637824475vh auto 0 auto;
        width: 58.45869439630272vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color:#111111;
        line-height: 4.31520395550062vh;
      }
      .titlle3 {
        margin: 8.07911001236094vh auto;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #ffffff;
        line-height: 3.3374536465vh;
        text-align: center;
        border-radius: 9.1px;
        width: fit-content;
        padding: 2.4624227441vh 1.1989601386vw;
        height: 4.5624227441vh;
        background: #2f6eff;
        border: #2f6eff 1px solid;

      }
      .titlle3:hover{

        color: #2168DB;
        border: #2168DB 1px solid;
        background: rgba(255, 255, 255, 0.5);
      }
    }
    .screen1 {
      //z-index:: 3;
      position: relative;
      width: 100%;
      height: 74vh;
      padding: 2.84301606922126vh 2.86077411900635vw  2.84301606922126vh 2.86077411900635vw;
      background-image: url("../../assets/serviceBanner.png");
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-color: transparent;
      /* Add any additional styling as needed */

      .layer2 {
        position: absolute;
        top: 18.1495673671199vh;
        left: 9.17157712305026vw;

        .title1 {
          width: fit-content;
          height: 5.77626699629172vh;
          font-size: 3.50606585788562vw;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 400;
          color: #2f6eff;
          line-height: 12.23733003708282vh;
        }

        .title2 {
          margin-top: 6.82076637824475vh;
          width: 33.45869439630272vw;
          height: fit-content;
          font-size: 1.0597920277vw;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 400;
          color: #2f6eff;
          line-height: 4.31520395550062vh;
        }
        .title4{
          height: 8.77626699629172vh;
          font-size: 1.6060658579vw;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 400;
          color: #2f6eff;
          line-height: 9.31520395550062vh;
        }
        .titlle3{
          margin-top: 2.07911001236094vh;
          //cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1vw;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 400;
          color: #ffffff;
          line-height: 3.3374536465vh;
          text-align: center;
          border-radius: 9.1px;
          width: fit-content;
          padding: 2.4624227441vh 1.1989601386vw;
          height: 4.5624227441vh;
          background: #2f6eff;
          border: #2f6eff 1px solid;

        }
        .titlle3:hover{

          color: #2168DB;
          border: #2168DB 1px solid;
          background: rgba(255, 255, 255, 0.5);
        }
      }


      //.layer3 {
      //  position: absolute;
      //  top: 5.06798516687268vh;
      //  right: 11.61178509532062vw;
      //  width: 47.42923165800116vw;
      //  height: 72.80593325092707vh;
      //  background-image: url("../assets/GPTplant.png");
      //  background-size: 100% auto;
      //  background-position: center;
      //  background-repeat: no-repeat;
      //  background-color: transparent;
      //  opacity: 1;
      //}
    }
    .screenmake0{
      padding: 7.78739184177998vh 8.09763142692085vw;
      width: 100%;
      height: fit-content;
      background: white;

      .heighLight {
        margin: 0 auto;
        text-align: center;
        height:8.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;

      }

      .heightLight2 {
        margin:0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;

        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }
      .grid{
        margin-top:2.78739184177998vh ;
        position: relative;
        .card{
          //cursor: pointer;
          width: 100%;
          height:fit-content ;
          padding:0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .back{
            //background: #EFF5FF;
            border-radius: 9px;
            display: flex;
            position: relative;
            //box-shadow: 2px 0 12px 0px #c9d9f5;
            height:fit-content ;
            overflow:hidden;
            .imgDesign{
              width: 45vw;
              height:fit-content;
              opacity: 1;
              //background-image: url("../../assets/menage6.png");
              background-position: center;
              background-size:cover;
              background-repeat: no-repeat;
              background-color: transparent;
            }
            .titleDesign{
              padding: 3.5248454883vh 2.5248454883vw 2.5248454883vh 2.5248454883vw;
              display: flex;
              justify-content: center;
              align-items: center;
              float: right;
              color: black;
              width: 50%;
              .title1{
                margin-top: 4vh;
                font-size: 1.1709416522vw;
                font-weight: bold;
              }
              .title2{
                text-align: justify;
                line-height: 3.194066749vh;
                font-size:   1vw;
              }
              .title3{
                margin-top: 2vh;
                line-height: 3.194066749vh;
                font-size:   1vw;
              }

            }

          }
        }

        ::v-deep .el-carousel__container{
          height: 65.87268232385661vh !important;
        }
        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }
        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }
        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
    .screenmake1{
      padding: 7.78739184177998vh 8.09763142692085vw;
      width: 100%;
      height: fit-content;
      background: transparent;

      .heighLight {
        margin: 0 auto;
        text-align: center;
        height:8.23733003708282vh;
        opacity: 1;
        font-size: 2.2060658579vw;
        //color: #53A3F7;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        line-height: 4.23733003708282vh;

      }

      .heightLight2 {
        margin:0 auto;
        text-align: center;
        height: 13.78739184177998vh;
        font-weight: 400;
        color: #2C3E50;
        line-height: 4.94437577255871vh;

        width: 60.9693818602vw;
        font-size: 1.0287117273vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
      }
      .grid{
        margin-top:2.78739184177998vh ;
        position: relative;
        .card{
          //cursor: pointer;
          width: 100%;
          height:fit-content ;
          padding:0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
          opacity: 1;

          .back{
            //background: #EFF5FF;
            border-radius: 9px;
            display: flex;
            position: relative;
            //box-shadow: 2px 0 12px 0px #c9d9f5;
            height:fit-content;
            overflow:hidden;
            .imgDesign{
              //margin-left: 5%;
              width: 45vw;
              height:fit-content;
              opacity: 1;
              //background-image: url("../../assets/menage6.png");
              background-position: center;
              background-size:cover;
              background-repeat: no-repeat;
              background-color: transparent;
            }
            .titleDesign{
              padding: 3.5248454883vh 2.5248454883vw 2.5248454883vh 2.5248454883vw;
              display: flex;
              justify-content: center;
              align-items: center;
              float: right;
              color: black;
              width: 50%;
              .title1{
                margin-top: 4vh;
                font-size: 1.1709416522vw;
                font-weight: bold;
              }
              .title2{
                text-align: justify;
                line-height: 3.194066749vh;
                font-size:   1vw;
              }
              .title3{
                margin-top: 2vh;
                line-height: 3.194066749vh;
                font-size:   1vw;
              }

            }

          }
        }

        ::v-deep .el-carousel__container{
          height: 65.87268232385661vh !important;
        }
        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }
        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }
        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
  }

}

.totalmakeHoleModel{
  background: #ebf1fd;
  overflow-x: hidden;
  width: 100vw;
  height: auto;
  position: relative;
  .makeHole1 {
    //z-index:: 3;
    position: relative;
    width: 100%;
    height: 100vh;
 .topback{
    position: fixed;
    z-index:999;
      width: 100vw;
      padding: 0 0 0 2.86077411900635vw;
    }
    .background{
      padding: 2.84301606922126vh 2.86077411900635vw  2.84301606922126vh 2.86077411900635vw;
      width: 100%;
      height: 400px;
      background-image: url("../../assets/menageBanner.png");
      background-position: center;
      background-size:cover;
      background-repeat: no-repeat;
      background-color: transparent;
      position: relative;
      /* Add any additional styling as needed */
      .layer2 {
        position: absolute;
        left: 0;

        .titlle1 {
          margin: 25px auto 0 auto;
          width: fit-content;
          text-align: center;
          height: fit-content;
          font-size: 22px;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 500;
          color: #111111;
          line-height: 22px;

        }

        .title4 {
          margin: 25px auto;
          width: 90%;
          text-align: center;
          height: 17px;
          font-size: 12px;
          font-family: Sarial, sans-serif, "Microsoft Yahei";
          font-weight: 400;
          color: #111111;
          line-height: 20px;
        }
      }
      .title3 {
        position: absolute;
        bottom:30px;
        left:50%;
        transform: translateX(-60%);
        font-size: 14px;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 9.1px;
        width: fit-content;
        margin: 0 15px;
        padding: 5px 4.6875vw;
        line-height: 15px;
        height: 35px;
        color:white;
        background-color: #2f6eff;
        border: 1px solid #2f6eff;
        overflow: hidden;


      }

    }
    .screenmake0{
      padding:30px 4.6875vw 20px 4.6875vw;
      width: 100%;
      height: fit-content;
      background: white;

      .heighLight {
        text-align: center;
        height: 20px;
        opacity: 1;
        font-size: 21px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;

      }

      .grid{
        margin-top:20px ;
        position: relative;
        .card{
          //cursor: pointer;
          width: 100%;
          height:fit-content ;
          padding:5px 5px;
          opacity: 1;
          .imgDesign{
            margin:0 auto;
            text-align: center;
            width: fit-content;
            height:200px;
            opacity: 1;
            //background-image: url("../../assets/menage6.png");
            background-position: center;
            background-size:cover;
            background-repeat: no-repeat;
            background-color: transparent;
          }
          .titleDesign{

            .title2{
              margin: 25px 12px 15px 12px;
              text-align: justify;
              height: fit-content;
              font-size:14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              line-height: 22px;
            }

          }

        }

        ::v-deep .el-carousel__container{
          height: 65.87268232385661vh !important;
        }
        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }
        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }
        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
    .screenmake1{
      padding:30px 4.6875vw 20px 4.6875vw;
      width: 100%;
      height: fit-content;
      background: transparent;

      .heighLight {
        text-align: center;
        height: 20px;
        opacity: 1;
        font-size: 21px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 700;
        line-height: 26px;

      }

      .grid{
        margin-top:20px ;
        position: relative;
        .card{
          //cursor: pointer;
          width: 100%;
          height:fit-content ;
          padding:5px 5px;
          opacity: 1;
          .imgDesign{
            margin:0 auto;
            text-align: center;
            width: fit-content;
            height:170px;
            opacity: 1;
            //background-image: url("../../assets/menage6.png");
            background-position: center;
            background-size:cover;
            background-repeat: no-repeat;
            background-color: transparent;
          }
          .titleDesign{

            .title2{
              margin: 25px 12px 15px 12px;
              text-align: justify;
              height: fit-content;
              font-size:14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              line-height: 22px;
            }

          }

        }

        ::v-deep .el-carousel__container{
          height: 65.87268232385661vh !important;
        }
        .el-carousel__item h3 {
          color: white;
          opacity: 0.75;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: transparent;
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: transparent;
        }
        ::v-deep .el-carousel__container {
          position: relative;
          height: 48.83559950556242vh;
        }
        ::v-deep .el-carousel__arrow {
          display: none;
          border: none;
          outline: 0;
          padding: 0;
          margin: 0;
          //cursor: pointer;
          transition: 0.3s;
          border-radius: 0;
          width: 1.15540150202195vw;
          height: 4.32632880098888vh;
          //background: #2168DB;
          color: #fff;
          position: absolute;
          top: 50%;
          //z-index:: 10;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
        }
      }
    }
  }

}
</style>
